import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ICountry, IStateAndProvince, PARSAction } from 'core/models';
import { countriesSelector, statesAndProvincesSelector } from './selectors';
import { getCountries, getStatesAndProvinces } from './actions';
import { ThunkDispatch } from 'redux-thunk';
import { AppState } from 'store';

export const useCountries = (): ICountry[] => {
  const dispatch: ThunkDispatch<AppState, unknown, PARSAction> = useDispatch();
  const countries: ICountry[] = useSelector(countriesSelector);
  useEffect(() => {
    if (!countries) {
      dispatch(getCountries());
    }
  }, [countries, dispatch]);
  return countries;
};

export const useStates = (): IStateAndProvince[] => {
  const dispatch: ThunkDispatch<AppState, unknown, PARSAction> = useDispatch();
  const states: IStateAndProvince[] = useSelector(statesAndProvincesSelector);
  useEffect(() => {
    if (!states) {
      dispatch(getStatesAndProvinces());
    }
  }, [states, dispatch]);
  return states;
};
